import { bearlog } from "@sillyscribe95/bear-ui-web";
import { mapBase } from "../functions/keyFuncs";

export let letterConst = [
  //
  "a",
  "s",
  "d",
  "f",
  "g",
  "h",
  "j",
  "k",
  // "l",
  //
  // "q",
  // "w",
  // "e",
  // "r",
  // "t",
  // "y",
  // "u",
  // "i",
];
export let numberConst = [
  //
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "0",
  "-",
  "=",
];

export let bassKey = [
  //
  "`",
  "z",
  "x",
  "c",
  "v",
  "b",
  "n",
  "m",
  ",",
  ".",
  "/",
];

export let keyArray = [
  //
  ...letterConst,
  ...numberConst,
];

let keyLett = {
  //
  65: addo(0),
  83: addo(2),
  68: addo(4),
  70: addo(5),
  71: addo(7),
  72: addo(9),
  74: addo(10),
  75: addo(12),

  //
  81: addo(0),
  87: addo(2),
  69: addo(4),
  82: addo(5),
  84: addo(7),
  89: addo(9),
  85: addo(11),
  73: addo(12),

  //
};

// 1bottom KEYS
const macBottom = [
  //
  16,
  //
  192, 90, 88, 67, 86, 66, 78, 77,
  //
  // 188, 190, 191,
];

export const bassDictConst = mapBase(macBottom, 12);

export let keyDict = {
  49: addo(0),
  50: addo(2),
  51: addo(4),
  52: addo(5),
  53: addo(7),
  54: addo(9),
  55: addo(11),
  56: addo(12),
  57: addo(14),
  48: addo(16),
  189: addo(17),
  187: addo(19),
  ...keyLett,
};

function bsso(asd = 0) {
  return asd + 40;
}

function addo(asd = 0) {
  return asd + 60;
}

function majorRend(key) {
  return [key, key + 4, key + 7];
}
function minorRend(key) {
  return [key, key + 3, key + 7];
}

let chordLett = {
  49: majorRend,
  50: minorRend,
  51: minorRend,
  52: majorRend,
  53: majorRend,
  54: minorRend,
  55: majorRend,
  56: majorRend,

  //
  81: minorRend,
  87: majorRend,
  69: majorRend,
  82: minorRend,
  84: minorRend,
  89: majorRend,
  85: minorRend,
  73: minorRend,
};

let chordnumb = {
  65: majorRend,
  83: minorRend,
  68: minorRend,
  70: majorRend,
  71: majorRend,
  72: minorRend,
  73: majorRend,
  74: majorRend,
  75: majorRend,
};

export let chorKeyDt = {
  ...chordnumb,
  ...chordLett,
};

let chordBase = {
  60: majorRend,
  62: minorRend,
  64: minorRend,
  65: majorRend,
  67: majorRend,
  69: minorRend,
  70: majorRend,
  72: majorRend,
};

export let chordDict = {
  ...chordBase,
  ...chorKeyDt,
};

export function roop(dict) {
  [1, 2, 3, 4, 5, 6, 7, 8].map(function (num) {
    dict[num + 7] = dict[num];
  });

  return dict;
}

// 1console
bearlog.lug(`___ keyDict ___`, keyDict);
bearlog.lug(`___ chordDict ___`, chordDict);
